import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * The loading placeholder for a section that is about to show a list.
 *
 * The app had three loading languages: `DataTable` rendered skeleton rows,
 * nine places spin a `Loader2`, and a dozen simply printed "Loading…" — which
 * reads as unfinished next to the other two. This is the shared shape for that
 * third case, so a section loads like the tables do.
 *
 * Text is still right where it IS the content: a "Load more" button's label, or
 * a row inside an open dropdown. Those are deliberately left alone.
 *
 * Three fixed rows rather than a mapped count — every caller wants the same
 * thing, and a mapped list here would need an array-index key.
 */
export function LoadingRows({ className }: { className?: string }) {
  return (
    <div className={cn("space-y-2", className)} aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading…</span>
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-2/3" />
    </div>
  );
}
